// extracted by mini-css-extract-plugin
module.exports = {"subtopicsList":"Topic_subtopicsList__KjAr0","subtopicsListItem":"Topic_subtopicsListItem__2zJhm"};